/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';

import { translate } from '../../common/translation/translate';
import { mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { AirQualitySubStoryLoadingUI } from '../airQuality/v2/loadingUI/airQualitySubStoryLoadingUI';
import { Story } from '../common/interfaces/types';
import { LifeSubStory } from '../common/life/lifeSubStory';
import { OutdoorSportsStoriesLoadingErrorUI } from './fallbackUI/outdoorSportsStoriesLoadingErrorUI';

const source = 'life/outdoor-sports/';
interface OutdoorStoriesType {
    outdoorSportsDataIsFetching: boolean;
    isApiError: boolean;
    sportsStories: Story[];
    enableSourceParameterOnStoriesLinks: boolean;
}

export const OutdoorStories  = memo(({
    outdoorSportsDataIsFetching,
    isApiError,
    sportsStories = [],
    enableSourceParameterOnStoriesLinks
}: OutdoorStoriesType) => {
    return (
        <Container isApiError={isApiError}>
            <Header isApiError={isApiError}>{`${translate('outdoorSportsStories')}`}</Header>
            { !outdoorSportsDataIsFetching && !sportsStories && isApiError && <OutdoorSportsStoriesLoadingErrorUI /> }
            <StoryCardList>
                {outdoorSportsDataIsFetching && !sportsStories && !isApiError && Array(...Array(6)).map((x, i) =>  {
                    return  <AirQualitySubStoryLoadingUI key={i} />;}
                )}
                {!outdoorSportsDataIsFetching && sportsStories && !isApiError && sportsStories.map((story: Story) => {
                    return (
                        <LifeSubStory
                            key={story.Id}
                            subStory={story}
                            enableSourceParameterOnStoriesLinks={enableSourceParameterOnStoriesLinks}
                            source={source}
                        />
                    );
                })}
            </StoryCardList>
        </Container>
    );
});

const Container = styled.div<{isApiError: boolean; }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: ${(props) => props.isApiError ? '450px': '' };
    background-color: ${(props) => props.isApiError ? '#F9F9F9': '' };
    margin: ${(props) => props.isApiError ? '10px 10px 0 0': '' };

    @media ${mediumMediaQuery} {
        margin-right: 0;
    }

     @media ${smallMediaQuery} {
        margin: 0 0;
    }
`;

const Header = styled.div<{isApiError: boolean; }>`
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    background-color: ${(props) => props.isApiError ? '#ffffff': '' };
    color: ${(props) => props.isApiError ? '#555555': '#ffffff' };
    border-bottom: ${(props) => props.isApiError ? '1px solid #EEEEEE': '' };
    padding: ${(props) => props.isApiError ? '15px 0 15px 20px': '30px 0 0 10px' };
    text-transform: uppercase;

    @media ${smallMediaQuery} {
        padding-top: 12px;
    }
`;

const StoryCardList = styled.ul`
    width: 100%;
    padding-left: 0;
    white-space: normal;

    @media ${mediumMediaQuery} {
        margin-left: 5px;
    }

    @media ${smallMediaQuery} {
        margin: 2px 0 4px 0;
    }
`;
